
String.prototype.format = function() {
    var args = arguments;

    function getMatch(object, key, match) {
        var value = object[key];
        return !_.isUndefined(value) ? value : match;
    }

    if (args.length === 1 && _.isObject(args[0])) {
        var dict = args[0];
        return this.replace(/{(\w+)}/g, function(match, key) {
            return getMatch(dict, key, match);
        });
    } else {
        return this.replace(/{(\d+)}/g, function(match, number) {
            return getMatch(args, number, match);
        });
    }
};
